module.exports = __webpack_public_path__ + "static/media/Picture 1.f1d1c5bb.jpg";